import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#000000',
    },

    secondary: {
      main: '#b20d35',
      dark: '#a10d35',
    },

    disabled: {
      background: '#d3d3d3',
      hovered: '#c7c5c5',
      font: '#888888',
    },

    white: {
      main: '#fff',
    },

    border: {
      main: '#e9e9e9',
    },
  },
});

export default theme;
